export default __webpack_public_path__ + "static/favicon-924973c834ce5e499347f3d0df870c78.png";